import React from 'react';

const Console = React.lazy(() => import('src/Console/Console'));

/**
 * @step 1900: router array  for application
 */
export const HomeRoutes = [
    {
        path: '/:slug',
        element: <Console/>,
    },
    {
        path: '/:slug/:spk',
        element: <Console/>,
    },
    {
        path: '/:slug/:spk/:sheet',
        element: <Console/>,
    },
    {
        path: '/:slug/:spk/:sheet/:param1',
        element: <Console/>,
    },
    {
        path: '/:slug/:spk/:sheet/:param1/param2',
        element: <Console/>,
    },
    {
        path: '/cons/:slug',
        element: <Console/>,
    },
    {
        path: '/cons/:slug/*',
        element: <Console/>,
    },
    {
        path: '/',
        element: <Console/>,
    }
];


